import React, { useEffect, useState } from 'react';

import { getEdlySiteConfig, updateEdlySiteConfig } from 'services/siteConfiguration';
import { messageNotification } from 'helpers';

const CertificateReadyNotifications = () => {
  const [checked, setCheckedBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getEdlySiteConfig()
      .then((res) => {
        setCheckedBox(!!res.data.lms.ENABLE_COURSE_CERTIFICATE_EMAIL);
      })
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
      });
  }, []);

  const handleClick = async () => {
    const updateCheck = !checked;
    setIsLoading(true);
    setCheckedBox(updateCheck);
    const data = { lms: { ENABLE_COURSE_CERTIFICATE_EMAIL: updateCheck } };
    updateEdlySiteConfig(data)
      .then(() =>
        messageNotification(
          'success',
          'Key updated',
          `Certificate-ready notifications have been ${updateCheck ? 'enabled' : 'disabled'}`
        )
      )
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
        setCheckedBox(!updateCheck);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="integration-holder mb-4">
      <div className="subheader-holder">
        <h5>Certificate-ready notifications</h5>
        <div className="checkbox_Container d-flex align-items-center">
          <p className="m-0 flex-grow-1">
            Receive email notifications when certificates have been generated and are ready for a course.
          </p>
          <input type="checkbox" checked={checked} className="checkbox flex-shrink-0" onChange={handleClick} />
          {isLoading && (
            <small className="text-muted ms-2 d-flex align-items-center">
              <span
                className="spinner-border me-1"
                role="status"
                style={{ width: '0.75rem', height: '0.75rem' }}
              ></span>
              Saving...
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default CertificateReadyNotifications;
